import { render, staticRenderFns } from "./PermissionDialog.vue?vue&type=template&id=42820857"
import script from "./PermissionDialog.vue?vue&type=script&lang=js"
export * from "./PermissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports